import moment from "moment-timezone";

export const formatMoney = (value) => {
  return new Intl.NumberFormat("es-AR", {
    style: "currency",
    currency: "ARS",
  }).format(value);
};

export const formatDate = (date) => {
  return moment(date).format("DD/MM/YYYY");
}

export const formatNumber = (value, decimals = 2) => {
  return new Intl.NumberFormat("es-AR", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(value);
}